import { AxiosInstance } from "axios"

export interface ResendAgencyInviteResponse {
  time: string
  apiStatus: string
  data: {
    userId: number
    email: string
    taPriceConfigId: number
    message: string
  }
}

export function resendAgencyInviteApi(
  userId: number,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: `/agent/agency/users/${userId}/resend-invite`,
  }) as Promise<{ data: ResendAgencyInviteResponse }>
}
